import React from 'react'
import { useWindowWidth } from '../__helpers/global-dom-events'
import { purgeTruskin, truskinMinWidth } from './ad-helpers/truskin'

/** This is a separate component to reduce re-renders in Site.tsx */
export const CleanupTruskin: React.FC<{}> = () => {
    const windowWidth = useWindowWidth()

    React.useEffect(() => {
        if (!windowWidth) return

        if (windowWidth < truskinMinWidth) {
            purgeTruskin()
        }
    }, [windowWidth])

    return null
}
